import React, { useEffect, useState } from 'react';
import { productAPI } from '../api/services';
import { useStoreSettings } from '../context/StoreSettingsContext';
import ProductCard from '../components/ProductCard';
import './Products.css';

function Deals() {
  const { settings } = useStoreSettings();
  const [products, setProducts] = useState([]);
  const [loading, setLoading]   = useState(true);

  useEffect(() => {
    const ids = (settings?.deals?.products || [])
      .map(p => typeof p === 'object' ? p.id : p)
      .filter(Boolean);

    if (ids.length === 0) { setLoading(false); return; }

    productAPI.getProductsByIds(ids)
      .then(r => setProducts(r.data || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [settings]);

  return (
    <div className="products-page">
      <div className="container">
        <div className="products-page-header">
          <h1>Day Sale</h1>
          <p>Best deals and discounted products</p>
        </div>

        {loading ? (
          <div className="loading"><div className="spinner" /></div>
        ) : products.length === 0 ? (
          <div className="no-products"><p>No deals available at the moment</p></div>
        ) : (
          <div className="grid grid-cols-4 products-grid">
            {products.map((p, i) => (
              <div key={p.id} className="product-grid-item" style={{ '--i': i }}>
                <ProductCard product={p} simple />
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default Deals;
